module.exports = __webpack_public_path__ + "img/MSB2.c79fa31e.png";